export const ACTIVITY_NAME_TO_ID_MAP = {
    "PICKLEBALL": 9,
    "BADMINTON": 1
}

export const COPLAYER_CARD_ENABLED = ["BADMINTON", "PICKLEBALL", "FOOTBALL"];
